import React from 'react';
import { Link } from 'expo-router';
import { useIntl } from 'react-intl';
import { View } from 'react-native';

import { slugify } from '@garnish/forms';

import { menuCategoriesGridProductCardLinkMessages as messages } from './MenuCategoriesGridProductCardLink.messages';
import { menuCategoriesGridProductCardLinkStyles as styles } from './MenuCategoriesGridProductCardLink.styles';
import { type MenuCategoriesGridProductCardLinkProps } from './MenuCategoriesGridProductCardLink.types';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuCategoriesGridProductCardLink = (
  props: MenuCategoriesGridProductCardLinkProps,
) => {
  const { href, productName, isNavigationEnabled, children, onPress } = props;

  const { formatMessage } = useIntl();

  // ─────────────────────────────────────────────────────────────────────

  const a11yLabel = formatMessage(messages.a11yLabel, {
    product_name: productName,
  });

  // ─────────────────────────────────────────────────────────────────────

  if (!isNavigationEnabled) {
    return <View style={styles.container}>{children}</View>;
  }

  return (
    <Link
      testID={`${slugify(productName)}-product-card-pressable`}
      href={href}
      onPress={onPress}
      aria-label={a11yLabel}
      style={styles.container}
    >
      {children}
    </Link>
  );
};
